import styled from "styled-components";

const Copy = styled.p.attrs(({ className }) => ({
  className: `font-franklin w-10/12 text-center text-mattamy-gray font-light ${className}`
}))`
  line-height: 1.625;
`;

export default Copy;
